import { IState } from '../../store';

export const selectIsNewbuildingPremiumRate = (state: IState): boolean => {
  return state.offerData.offer.newbuilding?.isTariffPremium;
};
